import "react/jsx-runtime";
const l = {
  default: 38,
  large: 44,
  small: 32
};
export {
  l as FieldSizeToNumber
};
//# sourceMappingURL=index.es2370.js.map
